<!--search and filter-->
<div class="filter_container">

  <div class="view-selection-container" *ngIf="viewConfig"> 
    <app-multi-select
        #viewselector
        id="view-selector"
        [options]="viewConfig.viewOptions"
        [displayKey]="'name'"
        [valueKey]="'id'"
        [isMultiSelect]="false"
        [placeholder]="'viewConfig?.placeHolder'"
        (selectionChange)="handleViewChange($event)"
      ></app-multi-select>
  </div>
  
  <div class="search_bar" *ngIf="searchBarConfig">
    <div class="search_container">
      <input
        type="text"
        name="search_table"
        id="search_table"
        [(ngModel)]="searchTerm"
        [placeholder]="searchBarConfig.placeHolder ?? 'Search...'"
        (keyup)="handleTableSearch($event)"
      >
      <img src="assets/icons/search_icon.svg" class="search_icon">
    </div>
  </div>

  <div class="filter_btn" *ngIf="filterConfig">
    <button (click)="filter()">
      <img src="assets/icons/filter.svg">
      Filters <app-svg-icon *ngIf="isFilterApplied" [path]="'assets/icons/circle_icon.svg'" style="background-color: var(--error-500);height: 8px;width: 8px"></app-svg-icon>
    </button>
  </div>
</div>

<!--stats-->
<div class="tos-table-template">
  @if (showTableStats) {
    <div class="table-stats">
      <div class="left">
        <div class="total">Total {{ tableMeta.name }}: {{ stats.total }}</div>
        <div class="active">Active: {{ stats.active }}</div>
        <div class="inactive">Inactive: {{ stats.inactive }}</div>
      </div>
    </div>
  }

  <!--table-->
  @if (isLoading) {
    <app-skeleton-loader></app-skeleton-loader>
  } @else {
    @if (dataListResponse.records.length === 0 && dataListRequest.where) {
      <app-no-data-found [msg]="'No Records Found.'"></app-no-data-found>
    } @else if(dataListResponse.records.length === 0) {
      <app-no-data [msg]="'No Records Available.'"></app-no-data>
    } @else {
      <div class="table-container">
        <table>
          <thead>
          <tr>
            <th class="cb_th select-all-cb">
              <input type="checkbox" id="selected_all" [checked]="isAllRecordsOfCurrentPageSelected()"
                     (change)="toggleAllRecordsOfCurrentPageSelections($event.target.checked)" />
            </th>
            @for (column of tableMeta.columns; track column.fieldName) {
              <th class="{{column.fieldName}}_th"
                  [class.sortable]="column.sortable"
                  [ngStyle]="column?.thStyleConfig"
                  mwlResizable
                  (resizing)="onResizeEnd($event, column.fieldName)">
                <div class="icon_cover" (click)="column.sortable && sortData(column.fieldName)">
                  {{ column.displayName }}
                  @if (orderByListContainsField(column.fieldName)) {
                    @if (this.dataListRequest.orderBy[column.fieldName] === "desc") {
                      <app-svg-icon
                        [path]="'assets/icons/sort_icon.svg'"
                        class="sort_icon"
                      ></app-svg-icon>
                    } @else {
                      <app-svg-icon
                        [path]="'assets/icons/up_arrow.svg'"
                        class="sort_icon"
                      ></app-svg-icon>
                    }
                  }
                  <div class="resize-handle-right" mwlResizeHandle [resizeEdges]="{ right: true }"></div>
                </div>
              </th>
            }
            <th class="sticky-actions actions_th" *ngIf="tableMeta?.actions?.length > 0"
                [ngStyle]="tableMeta?.actions?.[0]?.thStyleConfig || {}"></th>
            <th class="table_menu_th" *ngIf="showMenuOptions">
              <!--            <div class="icon_cover plus_icon">
                            <app-svg-icon
                              [path]="'assets/icons/plus_icon.svg'"
                            ></app-svg-icon>
                          </div>-->
            </th>
          </tr>
          </thead>
          <tbody>
            @for (record of dataListResponse.records; track record.id || $index; let recordIndex = $index) {
              <tr class="row" [ngClass]="isSelected(record) ? 'selected_row' : ''">
                <td class="cb_td row-select-cb">
                  <input type="checkbox" (change)="toggleSelection(record)" [checked]="isSelected(record)" />
                </td>
                @for (column of tableMeta.columns; track column.fieldName) {
                  <td class="{{column.fieldName}}_td" title="{{record[column.fieldName]}}">
                    <!--                  {{ record[column.fieldName] }}-->
                    <app-tos-table-td
                      [value]="getNestedValue(record, column.fieldName)"
                      [rowData]="record"
                      [column]="column"
                      (inlineAction)="handleInlineAction($event)"
                    ></app-tos-table-td>
                  </td>
                }
                <td class="sticky-actions actions_td" *ngIf="tableMeta?.actions?.length > 0">
                  <div class="action_buttons_wrapper">
                    @for (column of tableMeta.actions; track column.fieldName) {
                      <app-tos-table-td
                        [value]="getNestedValue(record, column.fieldName)"
                        [rowData]="record"
                        [column]="column"
                        (inlineAction)="handleInlineAction($event)"
                      ></app-tos-table-td>
                    }
                  </div>
                </td>

                <td class="table_menu_td" *ngIf="showMenuOptions">
                  <div class="menu_component">
                    <app-table-menu
                      [options]="tableMenuOptions"
                      [isOpen]="openMenuIndex === recordIndex"
                      (toggle)="handleMenuToggle(recordIndex)"
                      (optionSelected)="handleOptionSelected(record, $event)"
                      [tableRowData]="record"
                    >
                    </app-table-menu>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="pagination">
        <div class="button_wrapper_left">
          <button (click)="handlePreviousBtnClick()" [disabled]="!(dataListRequest.page > 0)"><img
            src="assets/icons/left-arrow.svg" /> Previous
          </button>
        </div>
        <!-- <ng-container *ngIf="totalPages" class="page_numbers">
          <div
            *ngFor="let page of getDisplayedPages()"
            (click)="page !== '...' ? goToPage(page) : null"
            [class.page_number]="page !== '...'"
            [class.ellipsis]="page === '...'"
            [class.active]="dataListRequest.page === page - 1"
          >
            {{ page }}
          </div>
        </ng-container> -->


        <ng-container>


          <div class="goto_page_box">
            <input type="number" min="1" [max]="totalPages" [(ngModel)]="customPageInput" [style.width.px]="inputWidth"
                   (ngModelChange)="onDebouncedPageInputChange()" />
            <span class="hidden-span" #widthCalculator>{{ customPageInput }}</span>
            <span class="total_pages_text">of {{ totalPages }}</span>
          </div>


        </ng-container>

        <div class="button_wrapper_right">
          <div class="rows_per_page">
            Rows per page
            <select class="select_dropdown" (change)="handleRowsPerPage($event)">
              <option value="15">15</option>
              <!--          <option value="25">25</option>-->
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
          <button (click)="handleNextButtonClick()"
                  [disabled]="!(this.dataListRequest.page >= 0 && this.dataListRequest.page < this.totalPages - 1)">Next
            <img src="assets/icons/right-arrow.svg"></button>
        </div>
      </div>
    }
  }
</div>
